import { render, staticRenderFns } from "./Insureds.vue?vue&type=template&id=18fcf4af"
import script from "./Insureds.vue?vue&type=script&lang=js"
export * from "./Insureds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports